(function() {
  'use strict';
  angular.module('app.careerDecisionProfileClient', []);
})();
